import React from 'react';

interface InputGroupProps {
  label?: React.ReactNode;
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  type?: string;
  placeholder?: string;
  required?: boolean;
  as?: 'input' | 'textarea';
  children?: React.ReactNode;
  name?: string;
  maxLength?: number;
  error?: boolean;
  errorMessage?: string | null;
  disabled?: boolean;
  [key: string]:
    | React.ReactNode
    | string
    | number
    | boolean
    | ((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void)
    | undefined;
}

export const InputGroup: React.FC<InputGroupProps> = ({
  label,
  value,
  onChange,
  type = 'text',
  placeholder,
  required,
  as = 'input',
  children,
  name,
  maxLength,
  error = false,
  errorMessage,
  disabled,
  ...rest
}) => (
  <div>
    {label && (
      <label
        className="font-ambit text-[0.9375rem] not-italic font-normal leading-[1.25rem] text-secondary"
        htmlFor={name}
      >
        {label}
        {required && '*'}
      </label>
    )}
    {children ? (
      <div>{children}</div>
    ) : as === 'textarea' ? (
      <textarea
        className={`w-full h-[8.3125rem] px-4 py-3 font-ambit text-[0.9375rem] not-italic font-normal leading-[1.25rem] rounded-2xl border transition-colors ${label ? 'mt-2' : ''} ${error ? 'border-[#F04438] bg-[#FEE4E2]' : 'border-primary/20 bg-[#F0F5F7] focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/10'}`}
        value={value}
        onChange={onChange as React.ChangeEventHandler<HTMLTextAreaElement>}
        placeholder={placeholder}
        name={name}
        id={name}
        maxLength={maxLength}
        aria-invalid={error || undefined}
        aria-describedby={error && errorMessage && name ? `${name}-error` : undefined}
        {...rest}
      />
    ) : (
      <input
        className={`w-full min-h-[2.75rem] px-4 py-2 font-ambit text-[0.9375rem] not-italic font-normal leading-[1.25rem] rounded-2xl border transition-colors ${label ? 'mt-2' : ''} ${error ? 'border-[#F04438] bg-[#FEE4E2]' : 'border-primary/20 bg-[#F0F5F7] focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/10'}${disabled ? ' opacity-50' : ''}`}
        type={type}
        value={value}
        onChange={onChange as React.ChangeEventHandler<HTMLInputElement>}
        placeholder={placeholder}
        required={required}
        name={name}
        id={name}
        maxLength={maxLength}
        disabled={disabled}
        aria-invalid={error || undefined}
        aria-describedby={error && errorMessage && name ? `${name}-error` : undefined}
        {...rest}
      />
    )}
    {error && errorMessage && (
      <div
        id={name ? `${name}-error` : undefined}
        className="text-[#F04438] text-[0.9375rem] font-ambit mt-1"
      >
        {errorMessage}
      </div>
    )}
  </div>
);
